import { render, staticRenderFns } from "./GenerationsHelp.vue?vue&type=template&id=7702c4ae&scoped=true&lang=pug&"
import script from "./GenerationsHelp.vue?vue&type=script&lang=js&"
export * from "./GenerationsHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7702c4ae",
  null
  
)

export default component.exports